(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-personalizado"] && !Shopify.designMode) return;
  try {
    
  // Añadir JavaScript si se necesita funcionalidad adicional.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-Yves"] && !Shopify.designMode) return;
  try {
    
  // JavaScript para interactividad adicional si es necesario

  } catch(e) { console.error(e); }
})();
})();
